// Song module
// ===========

// Mutations
// ---------
export const M_SONG_EDIT_MEASURE        = 'song/ADD_MEASURE';
export const M_SONG_DELETE_MEASURE      = 'song/DELETE_MEASURE';
export const M_SONG_ADD_PART            = 'song/ADD_PART';
export const M_SONG_DELETE_PART         = 'song/DELETE_PART';
export const M_SONG_SAVE_PART_NAME      = 'song/SAVE_PART_NAME';
export const M_SONG_UPDATE              = 'song/UPDATE';
export const M_SONG_LOAD                = 'song/LOAD_SONG';
export const M_SONG_TOGGLE_EDITION_MODE = 'song/TOGGLE_EDITION_MODE';
export const M_SONG_SET_EDITION_MODE    = 'song/SET_EDITION_MODE';
export const M_SONG_TOGGLE_IS_MODIFIED  = 'song/TOGGLE_IS_MODIFIED';

// Actions
// -------
export const A_SONG_EDIT_MEASURE        = 'song/ADD_MEASURE';
export const A_SONG_DELETE_MEASURE      = 'song/DELETE_MEASURE';
export const A_SONG_ADD_PART            = 'song/ADD_PART';
export const A_SONG_DELETE_PART         = 'song/DELETE_PART';
export const A_SONG_SAVE_PART_NAME      = 'song/SAVE_PART_NAME';
export const A_SONG_UPDATE              = 'song/UPDATE';
export const A_SONG_LOAD                = 'song/LOAD_SONG';
export const A_SONG_TOGGLE_EDITION_MODE = 'song/TOGGLE_EDITION_MODE';
export const A_SONG_SET_EDITION_MODE    = 'song/SET_EDITION_MODE';
export const A_SONG_TOGGLE_IS_MODIFIED  = 'song/TOGGLE_IS_MODIFIED';

// SongsList module
// ================

// Mutations
// ---------
export const M_SONGSLIST_ADD_SONG       = 'songsList/ADD_SONG';
export const M_SONGSLIST_DELETE_SONG    = 'songsList/DELETE_SONG';
export const M_SONGSLIST_UPDATE_SONG    = 'songsList/UPDATE_SONG';

// Actions
// -------
export const A_SONGSLIST_ADD_SONG       = 'songsList/ADD_SONG';
export const A_SONGSLIST_DELETE_SONG    = 'songsList/DELETE_SONG';
export const A_SONGSLIST_UPDATE_SONG    = 'songsList/UPDATE_SONG';

// App module
// ==========

// Mutations
// ---------
export const M_APP_ISMOBILE = 'app/ISMOBILE';

// Actions
// -------
export const A_APP_ISMOBILE = 'app/ISMOBILE';

// User module
// ===========

// Mutations
// ---------
export const M_USER_LOGIN = 'user/LOGIN';

// Actions
// -------
export const A_USER_LOGIN = 'user/LOGIN';
